"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.buildSubAccounts = exports.getAssetIdFromTokenId = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var account_1 = require("../../account");
var currencies_1 = require("../../currencies");
var operation_1 = require("../../operation");
var getAssetIdFromTokenId = function (tokenId) {
    return tokenId.split("/")[2];
};
exports.getAssetIdFromTokenId = getAssetIdFromTokenId;
var getAssetIdFromAsset = function (asset) {
    return "".concat(asset.asset_code, ":").concat(asset.asset_issuer);
};
var buildStellarTokenAccount = function (_a) {
    var parentAccountId = _a.parentAccountId, stellarAsset = _a.stellarAsset, token = _a.token, operations = _a.operations;
    var assetId = (0, exports.getAssetIdFromTokenId)(token.id);
    var id = "".concat(parentAccountId, "+").concat(assetId);
    var balance = (0, currencies_1.parseCurrencyUnit)(token.units[0], stellarAsset.balance || "0");
    var reservedBalance = new bignumber_js_1["default"](stellarAsset.balance).minus(stellarAsset.buying_liabilities || 0);
    var spendableBalance = (0, currencies_1.parseCurrencyUnit)(token.units[0], reservedBalance.toString());
    return {
        type: "TokenAccount",
        id: id,
        parentId: parentAccountId,
        starred: false,
        token: token,
        operationsCount: operations.length,
        operations: operations.map(function (op) {
            var _a;
            return (__assign(__assign({}, op), { id: (0, operation_1.encodeOperationId)(id, op.hash, op.extra.ledgerOpType), accountId: id, type: op.extra.ledgerOpType, value: (_a = new bignumber_js_1["default"](op.extra.assetAmount)) !== null && _a !== void 0 ? _a : op.value }));
        }),
        pendingOperations: [],
        balance: balance,
        spendableBalance: spendableBalance,
        swapHistory: [],
        creationDate: operations.length > 0
            ? operations[operations.length - 1].date
            : new Date(),
        balanceHistoryCache: account_1.emptyHistoryCache
    };
};
var buildSubAccounts = function (_a) {
    var currency = _a.currency, accountId = _a.accountId, assets = _a.assets, syncConfig = _a.syncConfig, operations = _a.operations;
    var _b = syncConfig.blacklistedTokenIds, blacklistedTokenIds = _b === void 0 ? [] : _b;
    var allTokens = (0, currencies_1.listTokensForCryptoCurrency)(currency);
    if (allTokens.length === 0 || assets.length === 0) {
        return undefined;
    }
    var tokenAccounts = [];
    assets.map(function (asset) {
        var token = (0, currencies_1.findTokenById)("stellar/asset/".concat(getAssetIdFromAsset(asset)));
        if (token && !blacklistedTokenIds.includes(token.id)) {
            tokenAccounts.push(buildStellarTokenAccount({
                parentAccountId: accountId,
                stellarAsset: asset,
                token: token,
                operations: operations.filter(function (op) {
                    return op.extra.assetCode === asset.asset_code &&
                        op.extra.assetIssuer === asset.asset_issuer;
                })
            }));
        }
    });
    return tokenAccounts;
};
exports.buildSubAccounts = buildSubAccounts;
//# sourceMappingURL=tokens.js.map